import networkFetch from "../network";
import { FETCH_DATA } from "../action/types";
import { fullPageLoader, showToast } from "../action"
import config from "../../Config";
import Cookie from "../../util/Cookie";
import i18n from "../../i18n";

export function fetchData(store) {
    return function (next) {
        return function (action) {
            switch (action.type) {
                case FETCH_DATA: {
		    console.log("FETCH DATA");
                    const {onSuccess,noLoading} = action.payload;
                    if(!noLoading){
		    console.log("FETCH DATA 1");
                     store.dispatch(fullPageLoader({showFullPageLoading: true, opacity: 0}));
                    }
		    console.log("FETCH DATA 5");
                    return networkFetch({
                        ...action.payload

                    }).then(_ => {
		    console.log("FETCH DATA 2 ");
                        if(!noLoading){
                            store.dispatch(fullPageLoader({showFullPageLoading: false}));
                        }
                        
		    console.log("FETCH DATA 3 ");
                        let data = _.data;
                        if (data.headers && data.headers.responseCode === "200") {
                            if(onSuccess && typeof onSuccess === "function"){
                                onSuccess(data.body || data);
                            }
                            return next({
                                ...action,
                                payload: {...action.payload, data: data.body}
                            });
                        } else if(data.headers && data.headers.responseCode && data.headers.responseMessage) {
                            const text = data.headers.responseMessage || "Something went wrong!!";
                            setTimeout(_ => {
                                store.dispatch(showToast({
                                    text,
                                    variant: "error",
                                }));
                            });
                        
                        } else {
                            return next({
                                ...action,
                                payload: {...action.payload, error: data.headers && data.headers.responseMessage}
                            });
                        }

                    }).catch(e => {
                        console.log("Middleware catch -->>",e)
                        store.dispatch(fullPageLoader({showFullPageLoading: false}));
                        if(e && e.response && e.response.status === 401){
                            Cookie.remove("X-Reycreo-Auth-Token", {domain : '.mybidwin.com'});
                            Cookie.remove("X-Reycreo-Id", {domain : '.mybidwin.com'} );
                            setTimeout(_ => {
                                window.location.href = `${config.BILLING_URL}/login`;
                            },1000);
                        } else {
				console.log("ELSE FETCH DATA 7")
				let msg =  i18n.t(e.message);
                            const text = e.message === "Network Error" ? "Check your Internet connection" : msg;
			console.log( msg);
                            setTimeout(_ => {
                                store.dispatch(showToast({
                                    text,
                                    variant: "error",
                                }));
                            });
                        }
                    })
                }

                default :
                    return next(action)
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/middleware/data.js